import React, { Component } from 'react';

class DashInputs extends Component {
    constructor(props) {
        super(props);
      
    }
    render() {
        return (
            <>
               <label htmlFor="input" className='col-12 px-0 mb-4'>
                      <span className='prof__input__txt'>{this.props.label}</span>
                      <div className="profile__inputs__cont d-flex justify-content-between mt-1">
                        <input className='profile__inputs' type={this.props.type} placeholder={this.props.pHolder} />
                        <img src="/imgs/dash/edit.svg" className='edit__inf' alt=""  />
                      </div>
               </label>
            </>
        );
    }
}

export default DashInputs;
